<template>
    <img :src="src" />
</template>

<script>
    export default {
        name: 'avatar',
        props: {
            user: {default: 0},
            size: {default: 'image'},
        },
        data() {
            return {
                src: "",
            }
        },
        watch: {
            user() {
                this.refresh();
            },
            size() {
                this.refresh();
            },
        },
        methods: {
            refresh()
            {
                this.$http.get('/api/avatar/' + this.user + '/' + this.size).then(response => {
                    this.src = response.data;
                });
            }
        },
        mounted()
        {
            this.refresh();
        },
    }
</script>
